export default __webpack_public_path__ + "static/media/guest_10_01_caue_oliveira.67a87d20.png";